<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    center
    title="结算明细--引入应收费用"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <SiruiSearch
        ref="baseInfoFormRef"
        :query="query"
        :columns="formColumn"
        labelWidth="120px"
        @changeCompanyHandler="changeCompanyHandler"
        @changeDepartmentHandler="changeDepartmentHandler"
        @changeProductTypeHandler="changeProductTypeHandler"
        @changeServiceTypeHandler="changeServiceTypeHandler"
        @resetBtnClick="resetBtnClickHandler"
        @searchBtnClick="queryBtnClickHandler"
      ></SiruiSearch>
      <!-- <vxe-grid
        border
        show-overflow
        resizable
        ref="settleAccountsRef"
        class="vxe-table-element"
        size="mini"
        align="center"
        :auto-resize="true"
        :data="tableData"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @select-change="handleSelectionChange"
        @select-all="handleSelectionChange"
        height="300"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.field"
          :title="item.title"
          :width="item.width"
        >
        </vxe-table-column>
      </vxe-grid> -->
      <sirui-table
        ref="siruiTable"
        :loading="loading"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :showToolbar="false"
        :columns="tableColumnList"
        :checkbox-config="{ checkMethod: checCheckboxkMethod2 }"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column type="checkbox" width="50" fixed="left"> </vxe-table-column>
        <vxe-table-column type="seq" width="50" title="序号"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in tableColumnList"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'unit'">{{
              basic_unit?.find((item) => item.value == row['unit'])?.label
            }}</template>
            <template v-else-if="item.field === 'productType'">{{
              productList?.find((item) => item.value == row['productType'])?.label
            }}</template>
            <template v-else-if="item.field === 'serviceType'">{{
              serviceAllList?.find((item) => item.value == row['serviceType'])?.label
            }}</template>
            <template v-else-if="item.field === 'processStatus'">{{
              row.processStatus == '0' ? '未处理' : '已处理'
            }}</template>
            <template v-else-if="item.field === 'multiBillingRuleFlag'">{{
              row.multiBillingRuleFlag == '0' ? '否' : '是'
            }}</template>
            <template v-else-if="item.field === 'confirmStatus'">{{
              ['01'].includes(row.confirmStatus) ? '待确认' : '已确认'
            }}</template>
            <template v-else-if="item.field === 'abnormalExpenseFlag'">{{
              ['0'].includes(row.abnormalExpenseFlag) ? '否' : '是'
            }}</template>
            <template v-else-if="item.field === 'expenseNo'">
              <div>{{ row[item.field] }}</div>
            </template>
            <template v-else-if="item.field === 'createMethod'">{{
              row.createMethod == '01' ? '系统' : '手动'
            }}</template>
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="primary" @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确认引入</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { formFields, tableColumnList } from './index.js';
  // import tradeMixin from './../../../../../../mixin/tradeMixin';
  import API from '@/api/intermodality/order';
  import BASE_API from '@/api/dataBase';
  import RECEIVABLES_TRADE from '@/api/receivablesAndPayables/trade.js';
  import RECEIVABLES_MULTIMODALTRANSPORT from '@/api/receivablesAndPayables/multimodalTransport.js';
  // import mulTransportMixin from '../../../index.js';
  export default {
    name: 'DeductionTableDialog',
    // mixins: [mulTransportMixin],
    data() {
      return {
        tableColumnList,
        dialogVisible: false,
        loading: false,
        query: {
          businessCompanyNo: '',
          businessDepartmentCode: '',
          contractNo: '',
          orderCode: '',
          instructionNoLike: '',
          expenseNoLike: '',
          productType: '',
          serviceType: '',
          expenseType: '',
          businessCategory: '02',
          expenseGenerationDateStart: '',
          expenseGenerationDateEnd: '',
          instructionIssueDateStart: '',
          instructionIssueDateEnd: '',
          processStatus: '0',
          confirmStatus: '02',
        },
        businessCompanyName: '',
        tableData: [],
        companyList: [],
        departmentList: [],
        selectionList: [],
        expenseTypeList: [],
        productList: [],
        serviceAllList: [],
        serviceList: [],
        lineDetailsList: [],
      };
    },
    mounted() {
      this.$nextTick(() => {
        this._getCompanyApi();
        this.getProductList();
        this.getServiceList();
      });
    },
    methods: {
      checCheckboxkMethod2({ row }) {
        let ids = this.lineDetailsList.map((item) => item.id);
        return !ids.includes(row.id);
      },
      openModal() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.getTableData();
        });
      },
      cancelHandler() {
        this.dialogVisible = false;
      },
      confirmHandler() {
        if (this.selectionList.length) {
          if (!this.query.orderCode) {
            let orderCodeList = [...new Set(this.selectionList.map((item) => item.orderCode))];
            if (orderCodeList.length > 1) {
              this.$message.error('所选内容的订单编号不一致');
              return;
            }
          }
          this.$emit('confirmHandler', this.selectionList);
          this.cancelHandler();
        } else {
          this.$message.error('请选择行');
        }
      },
      // 切换供应商
      changeSupplyChainMethod(val) {
        console.log(val, '修改客户');
        const rowData = val[0];
        this.query = {
          ...this.query,
          customerNo: rowData?.partnerCode,
        };
      },
      // 切换公司
      // changeCompanyHandler(val) {
      //   this.query = {
      //     ...this.query,
      //     businessDepartmentCode: '',
      //     businessCompanyNo: val,
      //   };
      // },
      // 修改合同
      changeContractMethod(val) {
        this.query.contractNo = val[0].contractNo;
        console.log(val, '修改合同');
      },
      handleSelectionChange(row) {
        console.log(row, 'row');
        this.selectionList = row;
        // this._computedAmount(selection);
      },
      // 表底合并
      footerMethod({ columns }) {
        const footerData = [
          columns.map((column, _columnIndex) => {
            if (_columnIndex === 2) {
              return '合计';
            }
            if (column.property === 'domesticAmount') {
              return 0;
            }
            return null;
          }),
        ];
        return footerData;
      },
      // 计算选中金额
      _computedAmount(selection) {
        const amount = selection.reduce((prev, cur) => prev + cur.domesticAmount, 0);
        const allTdDom = document.querySelector('.vxe-footer--row').querySelectorAll('td');
        const totalDom = allTdDom[allTdDom.length - 2];
        totalDom.querySelector('.vxe-cell').innerHTML = amount;
      },
      // 切换部门
      // changeDepartmentHandler({ val }) {
      //   this.query = {
      //     ...this.query,
      //     statementDepartmentNo: val.createDepartmentCode,
      //     statementDepartmentName: val.createDepartmentName,
      //   };
      // },
      // 修改客户
      changeCustomsMethod(val) {
        const rowData = val[0];
        this.query = {
          ...this.query,
          customerName: rowData?.partnerZhName,
          customerNo: rowData?.partnerCode,
        };
      },
      // 获取表格数据
      async getTableData() {
        console.log('搜索');
        // this.tableData = this.mockDataList;
        this.loading = true;
        const postData = {
          ...this.query,
          processStatus: this.query.processStatus == null ? null : +this.query.processStatus,
          pageNum: this.$refs.siruiTable.page.pageNum,
          pageSize: this.$refs.siruiTable.page.pageSize,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_TRADE.RECEIVABLESEXPENSE_QUERY,
          postData
        );
        console.log(data, '应收费用清单');
        this.loading = false;
        this.tableData = data.data?.records || [];
        this.tableData.forEach((item) => {
          item.domesticAmount = item.domesticAmount ? item.domesticAmount.toFixed(2) : '0.00';
          item.originalAmount = item.originalAmount ? item.originalAmount.toFixed(2) : '0.00';
        });
        this.$refs.siruiTable.setPageTotal(data.data?.total);
      },
      // 搜索
      queryBtnClickHandler() {
        console.log('搜索', this.query);
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.clearCheckboxReserve();
        // this.idList = [];
        this.getTableData();
      },
      // 重置
      resetBtnClickHandler() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this._getDepartmentByCompanyCodeApi(this.userInfo.companyCode);
        this.query = {
          ...this.query,
          businessCompanyNo: this.userInfo.companyCode,
          businessDepartmentCode: this.userInfo?.departmentCode,
        };
        this.businessCompanyName = this.userInfo.companyName;
        this.expenseTypeList = [];
        this.serviceList = [];
        this.getTableData();
      },
      // 修改每页条数
      handleSizeChange() {
        this.$refs.siruiTable.setPageNum(1);
        this.getTableData();
      },
      // 修改当前页
      handleCurrentChange() {
        this.getTableData();
      },
      // 获取公司
      async _getCompanyApi() {
        // console.log('开始获取公司', this.userInfo);
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        });
        if (data.code == 0) {
          // console.log(data.data, '???=====》》');
          this.companyList = data.data?.personCompanyInfo;
          // console.log(this.companyList, 'companyList');
          // console.log(this.userInfo.companyCode, 'this.userInfo.companyCode');

          if (!this.userInfo.companyCode) {
            // console.log('非userInfo');
            const companyCode = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyCode
              : null;
            const companyName = data.data.personCompanyInfo
              ? data.data.personCompanyInfo[0].companyName
              : null;
            this.query = {
              ...this.query,
              businessCompanyNo: companyCode,
              businessCompanyName: companyName,
            };
          } else {
            // console.log('userInfo');
            (this.query = {
              ...this.query,
              businessCompanyNo: this.userInfo.companyCode,
              // businessCompanyName: this.userInfo.companyName,
            }),
              (this.businessCompanyName = this.userInfo.companyName);
          }

          this._getDepartmentByCompanyCodeApi(this.query.businessCompanyNo, true);
        } else {
          console.error('获取公司失败');
        }
      },
      // 根据公司获取部门
      async _getDepartmentByCompanyCodeApi(companyCode, isFirst = false) {
        const { data } = await this.$axios.post(BASE_API.GET_PERSON_API, {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        });
        if (data.code == 0) {
          console.log(data.data, '部门信息');
          this.departmentList = data.data?.personDepartmentInfo;
          if (isFirst) {
            this.query = {
              ...this.query,
              businessDepartmentCode: this.userInfo?.departmentCode,
              // businessDepartmentName: this.userInfo?.departmentName,
            };
            this.businessDepartmentName = this.userInfo?.departmentName;
          }
        } else {
          console.error('获取部门失败');
        }
      },
      // 切换公司
      changeCompanyHandler(val) {
        // console.log(val, '切换公司');
        const item = this.companyList.find((item) => item.personCompanyCode == val);
        // console.log(item, '切换公司item');
        this.query = {
          ...this.query,
          businessDepartmentCode: '',
          // businessDepartmentName: '',
          businessCompanyNo: val,
          // businessCompanyName: item.personCompanyName,
        };
        this.businessCompanyName = item.personCompanyName;
        // 获取部门数据
        this._getDepartmentByCompanyCodeApi(val);
      },
      // 切换部门
      changeDepartmentHandler(val) {
        // console.log(val, '切换部门');
        // console.log(this.departmentList, 'this.departmentList');

        const item = this.departmentList.find((item) => item.personDepartmentCode == val);
        this.query = {
          ...this.query,
          businessDepartmentCode: val,
          // businessDepartmentName: item.personDepartmentName,
        };
        this.businessDepartmentName = item.personDepartmentName;
      },
      // 切换产品
      changeProductTypeHandler(val) {
        this.query.serviceType = '';
        this.query.expenseTypeList = [];
        this.expenseTypeList = [];
        this.serviceList = [];
        if (val == '0') {
          this.serviceList = this.serviceAllList.slice(0, 6);
        } else if (val == '1') {
          this.serviceList = this.serviceAllList.slice(6);
        }
      },
      // 切换服务
      async changeServiceTypeHandler(val) {
        console.log(val, '服务');
        this.query.expenseTypeList = [];
        this.expenseTypeList = [];
        if (!val) {
          return;
        }
        let postData = {
          serviceNo: val,
        };
        const { data } = await this.$axios.post(
          RECEIVABLES_MULTIMODALTRANSPORT.SERVICE_EXPENSELIST_API,
          postData
        );
        if (data.code == 0) {
          this.expenseTypeList = [];
          if (data.data.length) {
            data.data.map((item) => {
              this.expenseTypeList.push({
                label: item.expenseName,
                value: item.expenseNo,
              });
            });
          }
        }
        console.log(data, '根据服务类型获取费用类型');
      },

      // 产品列表
      getProductList() {
        this.$axios
          .post(API.DATA_DICT, {
            dictType: 'INTERMODALITY-PRODUCT-TYPE',
            tenantCode: this.userInfo.tenantCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.productList = res.data.data || [];
              console.log(res.data.data, '产品');
            }
          });
      },
      // 服务列表
      getServiceList() {
        this.$axios
          .post(API.DATA_DICT, {
            dictType: 'INTERMODALITY-SERVICE-TYPE',
            tenantCode: this.userInfo.tenantCode,
          })
          .then((res) => {
            if (res.data.code === 0) {
              this.serviceAllList = res.data.data || [];
              console.log(res.data.data, '服务');
            }
          });
      },
    },
    computed: {
      formColumn() {
        return formFields(this);
      },
      basic_unit() {
        return this.dictListMap.basic_unit;
      },
    },
  };
</script>

<style lang="scss" scoped></style>
